import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const VEHICLE_BY_VIN_RESOURCE = "vehicle" as const;
export const VEHICLE_BY_VIN_OPERATION = "search" as const;
export const VEHICLE_BY_VIN_API_PATH = `/v1/${VEHICLE_BY_VIN_RESOURCE}/${VEHICLE_BY_VIN_OPERATION}` as const;

export type VehicleByVinParameters = paths[typeof VEHICLE_BY_VIN_API_PATH]["post"]["parameters"]["query"];
export type VehicleByVinBody =
  paths[typeof VEHICLE_BY_VIN_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type VehicleByVinSearchResponse =
  paths[typeof VEHICLE_BY_VIN_API_PATH]["post"]["responses"][200]["content"]["application/json"];
export type VehicleByVinResponse = VehicleByVinSearchResponse["data"][number] | null;

export function useVehicleByVinQuery(vin: string, options?: Options<VehicleByVinParameters, VehicleByVinBody>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<VehicleByVinParameters, VehicleByVinBody>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    queryKey: [VEHICLE_BY_VIN_RESOURCE, vin, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<VehicleByVinSearchResponse>(
        VEHICLE_BY_VIN_API_PATH,
        {
          ...(optionsWithDefaultsResolved.body || {}),
          vin: [vin],
        },
        {
          params: requestParameters,
        },
      );

      return response.data.data[0] ?? null;
    },
    enabled: !!vin,
  });
}
